import { Address, Email, Name } from '@hc-frontend/core-types';
import { PlateName } from '@hc-frontend/features-leads';
import { z } from 'zod';

export const SubmitPersonalInformationPlateTrackingOptions = z.object({
  plateName: PlateName,
  firstName: Name.optional(),
  lastName: Name.optional(),
  email: Email.optional(),
  streetAddress: Address.optional(),
  phoneNumber: z.string().optional(),
});

// eslint-disable-next-line no-redeclare
export type SubmitPersonalInformationPlateTrackingOptions = z.infer<
  typeof SubmitPersonalInformationPlateTrackingOptions
>;
